"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RaffleScheduleDialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const mui_dialog_form_1 = require("@dzambalaorg/mui-dialog-form");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const types_1 = require("@framework/types");
const validation_1 = require("./validation");
const RaffleScheduleDialog = (props) => {
    const { initialValues, ...rest } = props;
    return ((0, jsx_runtime_1.jsx)(mui_dialog_form_1.FormDialog, { initialValues: initialValues, validationSchema: validation_1.validationSchema, message: "dialogs.schedule", testId: "RaffleScheduleForm", ...rest, children: (0, jsx_runtime_1.jsx)(mui_inputs_core_1.SelectInput, { name: "schedule", options: types_1.CronExpression, required: true }) }));
};
exports.RaffleScheduleDialog = RaffleScheduleDialog;
//# sourceMappingURL=index.js.map